import BcSimpleTableUx from './bc-simple-tableUx.vue'

export default BcSimpleTableUx
